import { AxiosInstance } from "axios"
import { GenericResponse } from "."

export interface MenuModel {
    id: number
    parent_id: MenuModel
    module_id: number
    name: string
    icon: string
    status: string
    lang: string
}

const menuApi = (apiInstance: AxiosInstance) => {
    const menusList = async (): Promise<GenericResponse> => {
        return apiInstance.get(`/menus/get-all-menus`)
    }

    return {
        menusList
    }
}

export default menuApi
